import moment from "moment";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

const StatusHistory = (props) => {
  const closePopup = () => {
    props.hide();
  };

  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval" style={{width:'100%'}}>
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  Status History
                </h4>
              </div>
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                  <table class="table table-striped">
                    <thead>
                      {" "}
                      <tr>
                        <th>Status</th>
                        <th>Action By</th>
                        <th>Message</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.previousKycStatuses.map((e) => {
                        return (
                          <tr>
                            <td>{e.status}</td>
                            <td>{e.actionby}</td>
                            <td>{e.message}</td>
                            <td>
                              {moment(e.time).format("DD MMM YYYY HH:mm")}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default StatusHistory;



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/statushistory.js